import React, {useState} from 'react';
import {BaseModal} from '@/components/modals';
import Button from './Button';
import i18n from 'i18n';

interface CompactListProps {
    title: string;
    items: string[];
    maxItems?: number;
}

const CompactList: React.FC<CompactListProps> = ({title, items, maxItems = 3}) => {
    const [showModal, setShowModal] = useState(false);

    if (items.length <= maxItems) {
        return (
            <p className="text-muted">
                {items.join(', ')}
            </p>
        );
    }

    const displayItems = items.slice(0, maxItems);

    return (
        <>
            <p className="text-muted">
                {displayItems.join(', ')}
                <span
                    className="text-primary ml-2"
                    style={{cursor: 'pointer', textDecoration: 'underline'}}
                    onClick={() => setShowModal(true)}
                >
                    ...total {items.length} items
                </span>
            </p>

            <BaseModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                title={title}
                footer={
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        {i18n.t('jt_close.text')}
                    </Button>
                }
            >
                <div className="row">
                    {items.map((item, index) => (
                        <div key={index} className="col-md-6 mb-2">
                            <span className="badge bg-light text-dark mr-1">
                                {item}
                            </span>
                        </div>
                    ))}
                </div>
            </BaseModal>
        </>
    );
};

export default CompactList;